(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arelio-choose"] && !Shopify.designMode) return;
  try {
    
if (!window.arelioExactBundleInitialized) {
  window.arelioExactBundleInitialized = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-arelio-exact-bundle="true"]');
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const productForm = form.closest('product-form');
    const submitButton = form.querySelector('[type="submit"]');
    const spinner = form.querySelector('.loading__spinner');
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const formData = new FormData(form);
    const variantId = Number(formData.get('id'));
    const targetQuantity = Number(formData.get('quantity')) || 1;

    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');
    spinner?.classList.remove('hidden');
    productForm?.handleErrorMessage();
    cart?.setActiveElement(document.activeElement);

    try {
      const cartResponse = await fetch(`${routes.cart_url}.js`);
      const cartState = await cartResponse.json();
      const existingLine = cartState.items.find((item) => item.variant_id === variantId);
      const sections = cart ? cart.getSectionsToRender().map((section) => section.id) : [];
      let response;

      if (existingLine) {
        response = await fetch(routes.cart_change_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: existingLine.key,
            quantity: targetQuantity,
            sections,
            sections_url: window.location.pathname
          })
        });
      } else {
        if (cart) {
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
        }

        response = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          body: formData
        });
      }

      const responseData = await response.json();
      if (!response.ok || responseData.status) {
        throw new Error(responseData.description || responseData.message || 'לא ניתן לעדכן את העגלה');
      }

      if (cart) {
        cart.renderContents(responseData);
      } else {
        window.location = routes.cart_url;
      }
    } catch (error) {
      productForm?.handleErrorMessage(error.message);
    } finally {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
    }
  }, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
